<template>
	<van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
		<van-list
			v-model:loading="loading"
			:finished="finished"
			finished-text="没有更多了"
			:immediate-check="false"
			@load="onLoad"
		>
			<Notice :list="list" />
			<!--					<News :list="list" />-->
		</van-list>
	</van-pull-refresh>
</template>

<script setup lang="ts">
import Notice from './Notice.vue'
import { getXxfwList, getNotice, getXxfbList } from '@/api'
import { useAuthStore } from '@/store/auth'
import { Toast } from 'vant'
import { sign } from '@/utils/md5Utils'

const filters = reactive<any>({
	start: 1,
	num: 100
})

const userStore = useAuthStore()
const role = computed(() => (['JZG'].includes(userStore.userInfo.F_QuickQuery) ? 1 : 2)) // 1教师，2学生

const loading = ref<boolean>(false)
const refreshLoading = ref<boolean>(false)
const finished = ref<boolean>(false)
const list = ref<Array<any>>([])

onMounted(() => {
  queryList()
  // getXcList()
})

const queryList = async () => {
	Toast.loading({
		duration: 0
	})
	const { signStr, timestamp } = sign()
	const res = await getXxfwList({
		userId: userStore.userInfo.F_UserId,
		timestamp: timestamp,
		sign: signStr,
		...filters
	})
	let data = res.data || []
	Toast.clear()
	loading.value = false
	refreshLoading.value = false
	if (data.length < filters.num) {
		finished.value = true
	}
	if (filters.start === 1) {
		list.value = []
	}
	list.value = list.value.concat(data)
	// const storage = {
	//   type: type.value,
	//   value: list.value
	// }
	// sessionStorage.setItem('information', JSON.stringify(storage))
}

const onRefresh = () => {
	filters.start = 1
	queryList()
}
const onLoad = () => {
	console.log(3)
	filters.start++
	queryList()
}
defineExpose({ filters, queryList })
</script>

<style scoped lang="scss"></style>
